// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_1e-1";
export var movingGradient = "_1e-4";
export var movingGradientBlock = "_1e-2";
export var skeleton = "_1e-0";
export var skeletonText = "_1e-3";